import { Flex } from '@billy/design-system'
import React from 'react'

import { ConnectForm, ConnectFormType } from '../ConnectForm'
import { ErrorMessage } from '../ErrorMessage'
import { FormLabel } from '../FormLabel'
import { InputProps } from '../Input'
import * as Styled from './styles'

export type FieldsetProps = {
  children?: React.ReactElement<InputProps>[] // Limit children to valid inputs
  className?: string
  inline?: boolean
  label?: string
  name?: string
}

export const Fieldset = ({ children, className, inline, label, name }: FieldsetProps) => {
  const names = [] as string[]
  let required = false
  React.Children.forEach(children || [], (child: React.ReactElement<InputProps>) => {
    child.props.name && names.push(child.props.name)
    required = required || !!(child.props.required || child.props.options?.required)
  })
  return (
    <ConnectForm>
      {({ formState }: ConnectFormType) => {
        const errors = formState?.errors || {}

        return (
          <Styled.FieldsetContainer className={className} name={name}>
            {label && <FormLabel required={required}>{label}</FormLabel>}
            <Flex flexDirection={inline ? 'row' : 'column'} justifyContent="flex-start" align-items="start">
              {React.Children.map(
                children as React.ReactElement<InputProps>[],
                (child: React.ReactElement<InputProps>): JSX.Element | null =>
                  React.isValidElement(child) ? React.cloneElement(child, { silent: true }) : null,
              )}
            </Flex>
            {names.map((name) => errors[name] && <ErrorMessage key={name} error={errors[name]} />)}
          </Styled.FieldsetContainer>
        )
      }}
    </ConnectForm>
  )
}
